import { Box, Card, CardContent, IconButton, Typography, useTheme } from '@mui/material';
import { useCheckLogin, usePasswordChange } from '_api/index';
import { SEVERITY } from '_constants/derived';
import { ThumbnailView } from 'components/atoms';
import { PatientSubHeader } from 'components/atoms/typographyStyles';
import { AlertMessage } from 'components/molecules';
import { ChangePasswordModal, UploadPhotoModal } from 'components/organisms/modals';
import React, { useState } from 'react';
import { CgProfile } from 'react-icons/cg';
import { FaCamera, FaLock } from 'react-icons/fa';

import { ProfileCardProps } from './types';

export const ProfileCard = ({ account }: ProfileCardProps) => {
  const theme = useTheme();
  const { mutateAsync: passwordChange } = usePasswordChange();
  const [openPasswordChange, setOpenPasswordChange] = useState(false);
  const [openUploadPhoto, setOpenUploadPhoto] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const { data: me } = useCheckLogin();
  const handlePasswordChange = (newPassword: string, newPasswordConfirmation: string) => {
    passwordChange({ newPassword, newPasswordConfirmation })
      .then(() => {
        setOpenPasswordChange(false);
      })
      .catch((error) => setErrorMessage(error.message));
  };

  return (
    <Card>
      <CardContent>
        <Box alignItems="center" display="flex" flexDirection="column">
          {account && account.fullImageUrl ? (
            <ThumbnailView fullImageUrl={account.fullImageUrl} />
          ) : (
            <CgProfile />
          )}
          <Typography gutterBottom sx={{ marginBottom: 5 }} variant="h6">
            {account.firstName + ' ' + account.lastName}
          </Typography>
          <PatientSubHeader variant="body2">
            {account.accountType ? account.accountType : ''}
          </PatientSubHeader>
        </Box>
        {account?.email === me?.email ? (
          <Box
            sx={{
              alignItems: 'center',
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-evenly',
              paddingTop: '50px',
            }}
          >
            <IconButton
              onClick={() => setOpenUploadPhoto(true)}
              size="small"
              sx={{ color: theme.palette.primary.main }}
            >
              <FaCamera style={{ paddingBottom: '4px' }} />
              <Typography variant="body2" sx={{ fontSize: '12px', paddingLeft: '5px' }}>
                UPLOAD PHOTO
              </Typography>
            </IconButton>
            <Typography variant="body2" sx={{ alignSelf: 'center' }}>
              |
            </Typography>
            <IconButton
              onClick={() => setOpenPasswordChange(true)}
              size="small"
              sx={{ color: theme.palette.primary.main }}
            >
              <FaLock style={{ paddingBottom: '4px' }} />
              <Typography variant="body2" sx={{ fontSize: '12px', paddingLeft: '5px' }}>
                UPDATE PASSWORD
              </Typography>
            </IconButton>
          </Box>
        ) : null}
      </CardContent>
      <ChangePasswordModal
        onClose={() => setOpenPasswordChange(false)}
        open={openPasswordChange}
        onSubmit={handlePasswordChange}
      />
      <UploadPhotoModal
        account={account}
        onClose={() => setOpenUploadPhoto(false)}
        open={openUploadPhoto}
      />
      <AlertMessage
        severity={SEVERITY.error}
        open={!!errorMessage}
        onClose={() => setErrorMessage('')}
        message={errorMessage}
      />
    </Card>
  );
};
